import styled from 'styled-components';
import MuiCollapse from '@material-ui/core/Collapse';
import { tokens, palette } from '../../styles';

// icon
import { ArrowDown } from '../Icons';

export const Wrapper = styled.div`
  border: 1px solid ${palette['color-grey-300']};
  border-radius: ${tokens.borderRadius};
  transition: box-shadow 0.2s ease-in-out;

  ${({ isOpen }) => isOpen && 'box-shadow: 0px 24px 40px rgba(0, 0, 0, 0.15);'}
`;

export const Header = styled.header`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  text-align: left;
  cursor: pointer;
  padding: ${tokens.spacing.l} ${tokens.spacing.xl} ${tokens.spacing.l} ${tokens.spacing['xxl-5']};

  &:focus,
  &:hover {
    outline: 0;
  }

  svg {
    transition: transform 0.2s ease-in-ease-out;
  }

  ${({ isOpen }) => isOpen && ``}
`;

export const ChevronDown = styled(ArrowDown)`
  position: absolute;
  left: ${tokens.spacing.l};
  top: 50%;
  margin-top: -16px;
  transition: transform 0.2s ease-in-out;

  ${({ isOpen }) => isOpen && 'transform: rotate(180deg)'}
`;

export const Body = styled(MuiCollapse)``;
